import { gettext } from '@eventbrite/i18n';
import {
    ChevronLeftIcon,
    ChevronRightIcon,
    IconButton,
} from '@eventbrite/marmalade';
import React, { forwardRef, useEffect, useRef } from 'react';
import styles from './categoryFilterBar.module.scss';
import { useButtonScroll, useScrollCarousel } from './hooks';

export type CarouselProps = {
    children: Array<JSX.Element>;
    scrollPosition?: number;
};

export const Carousel = forwardRef<HTMLDivElement, CarouselProps>(
    ({ children, scrollPosition = 0 }, scrollBarRef) => {
        const scrollBarContainerRef = useRef<HTMLDivElement>(null);
        const { showLeftArrow, rightScrollDisabled } = useButtonScroll(
            scrollBarRef as React.RefObject<HTMLDivElement>,
        );
        const { scrollCarousel } = useScrollCarousel(
            scrollBarRef as React.MutableRefObject<HTMLDivElement>,
        );

        useEffect(() => {
            scrollBarRef as React.MutableRefObject<HTMLDivElement>;
            if (
                (scrollBarRef as React.MutableRefObject<HTMLDivElement>)
                    ?.current
            ) {
                (
                    scrollBarRef as React.MutableRefObject<HTMLDivElement>
                ).current.scrollLeft = scrollPosition;
            }
        }, [scrollBarRef, scrollPosition]);

        return (
            <div
                className={styles.carousel}
                id="chip-carousel"
                ref={scrollBarContainerRef}
            >
                <IconButton
                    id={styles.leftCarousel}
                    icon={<ChevronLeftIcon size="xlarge" />}
                    outline={true}
                    data-testid="leftScroll"
                    aria-label={gettext('left arrow button')}
                    variant="default"
                    data-hidden={!showLeftArrow}
                    className={`${styles.arrowButton} ${
                        showLeftArrow ? styles.show : styles.hide
                    }`}
                    onClick={() => scrollCarousel(-1)}
                />

                <div className={styles.chips} ref={scrollBarRef} id="scrollbar">
                    {children}
                </div>

                <IconButton
                    id={styles.rightCarousel}
                    icon={<ChevronRightIcon size="xlarge" />}
                    outline={true}
                    data-testid="rightScroll"
                    aria-label={gettext('right arrow button')}
                    variant="default"
                    className={styles.arrowButton}
                    onClick={() => scrollCarousel(1)}
                    disabled={rightScrollDisabled}
                />
            </div>
        );
    },
);
